import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import React from 'react';
import {useTranslation} from 'react-i18next';

interface CCMShowFullNotesDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  notes: React.ReactNode;
}
const CCMShowFullNotesDialog = (
  props: CCMShowFullNotesDialogProps
): JSX.Element => {
  const {open, onClose, notes, title} = props;
  const {t} = useTranslation();
  return (
    <Dialog maxWidth={'md'} fullWidth={true} open={open} onClose={onClose}>
      <DialogTitle disableTypography>
        <p>{title}</p>
      </DialogTitle>
      <DialogContent dividers className="content-wrapper">
        <div style={{wordBreak: 'break-all'}}>{notes}</div>
      </DialogContent>
      <DialogActions>
        <Button variant={'contained'} onClick={onClose} color="primary">
          {t('COMMON.CLOSE')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default CCMShowFullNotesDialog;
